import { Tabs, TabsProps } from "antd";
import AboutSalon from "../../components/settings/TapsSalon/AboutSalon";
import AboutBranches from "../../components/settings/TapsSalon/AboutBranches";
import AboutPeriods from "../../components/settings/TapsSalon/AboutPeriods";
import { FormattedMessage } from "react-intl";

type Props = {};

const Salon = (props: Props) => {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <div className="text-[#4f5062] w-full px-2 py-1">
          <FormattedMessage id="AboutTheSalon" />
        </div>
      ),
      children: <AboutSalon />,
    },
    {
      key: "2",
      label: (
        <div className="text-[#4f5062] w-full px-2 py-1">
          <FormattedMessage id="Branches" />
        </div>
      ),
      children: <AboutBranches />,
    },
    {
      key: "3",
      label: (
        <div className="text-[#4f5062] w-full px-2 py-1">
          <FormattedMessage id="ClosedPeriods" />
        </div>
      ),
      children: <AboutPeriods />,
    },
  ];
  const onChange = (key: string) => {
    console.log(key);
  };
  return (
    <div className="w-full">
      <div className="text-color-primary text-2xl font-semibold leading-7 flex items-center gap-2 text-end">
        <span className="">
          <FormattedMessage id="titleSalon" />
        </span>
      </div>
      <div className="my-4 text-color-gray text-base font-normal leading-7 ">
        <FormattedMessage id="subSalonTitle" />
      </div>
      <div className="settings">
        <Tabs
          defaultActiveKey="1"
          items={items}
          onChange={onChange}
          tabBarStyle={{ margin: 0 }}
        />
      </div>
    </div>
  );
};

export default Salon;
